export const DOCUMENT_TYPE_PAGE = 'page';
